<header class="app-header">

  <h1 class="logo">
    <a href="https://www.exostar.com/" target="_blank" rel="noopener noreferrer">
      @if(logo){
        <img [src]="logo" alt="Exostar - Supplier Management">
      }
      @else {
        <img src="assets/img/getlogo.png" alt="Exostar - Supplier Management">
      }
    </a>
    <a [href]="homeUrl">
      <span class="application-title">Supplier Management</span>
    </a>
  </h1>

  <nav class="glob-nav">
    <ul>
      <li class="help">
        <a [href]="homeUrl"><i class="fa fa-home" aria-hidden="true"></i>&nbsp;<span>Home</span></a>
      </li>
      <li class="help">
        <a [href]="userDetials?.MyExostar || userDetials?.myExostar || '#'" target="_blank" rel="noopener noreferrer"><span>myExostar</span></a>
      </li>
      <li class="help">
        <a [href]="(userDetials?.ContactUsEmail || userDetials?.contactUsEmail) ? 'mailto:' + (userDetials?.ContactUsEmail || userDetials?.contactUsEmail) : '#'"><span>Contact Us</span></a>
      </li>

      <li class="welcome-user dropdown">
        <i class="fa fa-user-circle ellipse1" aria-hidden="true"></i>
        <button type="button" class="user-trigger" (click)="toggleDropdown()" aria-haspopup="true" [attr.aria-expanded]="showDropdown">
          <p>
            {{ userDetials?.UserName || userDetials?.userName }}
            <i class="fa-solid fa-caret-down caret" aria-hidden="true"></i>
            <i class="fa fa-lock profile-2fa" aria-hidden="true" title="Elevated Credential"></i>
            <span class="sr-only">Elevated Credential</span>
          </p>
          <span>{{ userRole }}</span>
        </button>

        @if(showDropdown){
          <ul class="welcome-user-drop">
            <li>
              <a [href]="userDetials ? homeUrl + '/user-profile/' + (userDetials?.UserId || userDetials?.userId) : '#'">My Profile</a>
            </li>
            <li>
              <button type="button" class="dropdown-item" (click)="logout()">Logout</button>
            </li>
          </ul>
        }
      </li>
    </ul>
  </nav>

</header>
